<template>
  <div class="main display-flex">
    <Result
      :icon="getIcon('img/credit-line/success_heart.svg')"
      :title="t('CREDIT_LINE_FEEDBACK.THANKS_FOR_FEEDBACK')"
      :description="t('CREDIT_LINE_FEEDBACK.UNLINK_BANK_ACCOUNT_THANKS')"
      :btn-text="t('CREDIT_LINE_FEEDBACK.GO_TO_HOME')"
      @dismissFunc="dismiss()"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Result from "@/apps/credit-line/components/Result.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
declare const Android: AndroidInterface;
export default defineComponent({
  name: "UnlinkBankAccountSurveyResultView",
  components: { Result },
  methods: {
    getIcon(path: string): string {
      return useAsset(path);
    },
    dismiss() {
      Android.dismissWebView();
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
</style>
